module.exports = __webpack_public_path__ + "static/media/maren.1a45b984.png";